<template>
  <div class="page_bg " style="background: #3272C8;">
    <div class="bg_top_linear-gradient agency_bg_bsbj" style="background-color: none;">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-r-sb-c">
        <van-icon name="arrow-left" @click="backPath" />
        <div class="top_name" />
        <div class="top_icon" />
      </div>
    </div>
    <div class="top_brand flex-r-sa-c">
      <div :class="choosedBrand === 1 ? 'brand_item item_active':'brand_item' " @click="changeBrand('贝思倍健')">
        贝思倍健
      </div>
      <div :class="choosedBrand === 2 ? 'brand_item item_active':'brand_item' " @click="changeBrand('Petsmile')">
        Petsmile </div>
    </div>
    <div>
      <MyscrollList ref="myList01" :list="proList" @myload="proload">
        <template #default="slotProps">
          <proCard01 :info="slotProps.item" />
        </template>
      </MyscrollList>
    </div>
  </div>
</template>

<script>
import './index.scss'
import { apiWholesaleProduct_productList } from '@/api/pro'
import MyscrollList from '@/components/MyscrollList'
import proCard01 from '@/components/pro_card_01'
export default {
  name: 'Agency',
  components: { MyscrollList, proCard01 },
  data() {
    return {
      choosedBrand: 1,
      searchForm: { page: 1, limit: 10, brand: '贝思倍健' },
      proList: []
    }
  },
  created() { this.onSearch() },
  methods: {
    backPath() { window.history.back() },
    changeBrand(brand) {
      if (brand === '贝思倍健') { this.choosedBrand = 1 } else { this.choosedBrand = 2 }
      this.searchForm.page = 1
      this.searchForm.limit = 10
      this.searchForm.brand = brand
      this.proList = []
      this.onSearch()
    },
    // 查询事件
    onSearch() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      this.$set(this.searchForm, 'name', this.serValue)
      apiWholesaleProduct_productList(this.searchForm).then(res => {
        this.$toast.clear()
        // this.overlayShow = false
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        // 存localstrong
        if (this.searchForm.page === 1 && res.data.list.length === 0) {
          this.$refs.myList01.load_empty('ser', true)
        } else {
          if (res.data.list.length < 10) { // 数据全部加载完成
            if (res.data.list.length > 0) { this.$refs.myList01.load_finished(true) }
          }
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.searchForm.page = this.searchForm.page + 1
        this.onSearch()
      }, 50)()
    }
  }
}
</script>
